// extracted by mini-css-extract-plugin
export default {"container":"xAH0mk","responsive":"_MlcyF","title":"NBw1Kz","onImageTitle":"P4qjxu","button":"BoD93f","onImageButton":"CKLKOJ","link":"zLSZXO","hidden":"QQZ4S5","mobile":"bEXKbn"};